<template>
    <!-- never hydrate -->
    <LazyHydration :hydrate="() => {}">
        <div data-allow-mismatch>
            <noscript>NON-CRITICAL-CSS-INJECT</noscript>
        </div>
    </LazyHydration>
</template>
<script setup lang="ts">
import LazyHydration from './LazyHydration.vue'
</script>
